import LinkTreeList from './views/linkTreeList.vue';
import LinkTree from './LinkTree.vue';

export const linkTreeRoutes = [
  {
    path: 'linkTree',
    component: LinkTree,
    children: [
      { path: '', component: LinkTreeList, name: 'linkTree', }
    ]
  }
];
